import React from 'react';
import { BRAND } from '../../data/mock';
import { Button } from '../ui/button';
import { ArrowRight } from 'lucide-react';

export const MarketingGraphics = () => {
  return (
    <section className="py-16 md:py-20 bg-slate-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-8">
          {/* Cover Your Tail Graphic */}
          <div className="group relative rounded-3xl overflow-hidden shadow-2xl hover:shadow-3xl transition-shadow duration-300">
            <img
              src="https://customer-assets.emergentagent.com/job_petcover-broker/artifacts/5bgxfz8w_Screenshot%202025-12-31%20145832.png"
              alt="Cover Your Tail - Pet Insurance"
              className="w-full h-auto group-hover:scale-105 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
            <div className="absolute bottom-6 left-6 right-6 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
              <Button
                asChild
                className="w-full text-white font-bold"
                style={{ background: 'linear-gradient(135deg, #f97316 0%, #fb7185 100%)' }}
              >
                <a href={BRAND.quoteUrl} target="_blank" rel="noopener noreferrer">
                  Get Quote
                  <ArrowRight className="w-4 h-4 ml-2" />
                </a>
              </Button>
            </div>
          </div>

          {/* Comfort in Coverage Graphic */}
          <div className="group relative rounded-3xl overflow-hidden shadow-2xl hover:shadow-3xl transition-shadow duration-300">
            <img
              src="https://customer-assets.emergentagent.com/job_petcover-broker/artifacts/xi7t1bwi_Screenshot%202025-12-31%20145906.png"
              alt="The Comfort in Coverage - Pet Insurance"
              className="w-full h-auto group-hover:scale-105 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
            <div className="absolute bottom-6 left-6 right-6 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
              <Button
                asChild
                className="w-full text-white font-bold"
                style={{ background: 'linear-gradient(135deg, #f97316 0%, #fb7185 100%)' }}
              >
                <a href={BRAND.quoteUrl} target="_blank" rel="noopener noreferrer">
                  Get Quote
                  <ArrowRight className="w-4 h-4 ml-2" />
                </a>
              </Button>
            </div>
          </div>
        </div>

        {/* CTA below graphics */}
        <div className="text-center mt-12">
          <p className="text-slate-400 mb-4">
            Peace of mind starts with a free quote
          </p>
          <Button
            asChild
            size="lg"
            className="text-white font-bold text-lg px-10 py-6 shadow-xl shadow-orange-500/30 hover:scale-105 transition-all"
            style={{ background: 'linear-gradient(135deg, #f97316 0%, #fb7185 100%)' }}
          >
            <a href={BRAND.quoteUrl} target="_blank" rel="noopener noreferrer">
              Get Your Free Quote Now
              <ArrowRight className="w-5 h-5 ml-2" />
            </a>
          </Button>
        </div>
      </div>
    </section>
  );
};
